import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Box } from '@/components/blocks/Box';
import { Button } from '@/components/blocks/Button';
import { Flex } from '@/components/blocks/Flex';
import { Icon } from '@/components/blocks/Icon';
import { Text } from '@/components/blocks/Text';
import { theme } from '@/styles/theme';

interface Props {
  onRetry: () => void;
}

const Root = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    padding: theme.spaces.l,
    textAlign: 'center',
  })
);

const IconBox = styled(Box)({
  width: 40,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
});

export const ErrorFallback = ({ onRetry }: Props) => {
  return (
    <Root>
      <IconBox>
        <Icon icon='alert' />
      </IconBox>
      <Box marginTop={theme.spaces.xl}>
        <Text use='l-B' block>
          画面を表示できませんでした
        </Text>
      </Box>
      <Box marginTop={theme.spaces.m}>
        <Text use='s-N' block>
          通信状況の良い場所で、再度お試しください。
        </Text>
      </Box>
      <Box marginTop={theme.spaces.xl} width='100%'>
        <Button use='primary' full onClick={onRetry}>
          再試行
        </Button>
      </Box>
    </Root>
  );
};
